import React from 'react';
import {
  Section,
  Container,
  SectionHeader,
  CredentialCard,
} from '../components';
import {
  aboutHero,
  aboutBio,
  quickFacts,
  credentials,
  // careerHighlights,
} from '../data/content';

const AboutPage = ({ onNavigate }) => {
  const goToContact = () => {
    onNavigate('home');
    setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <>
      {/* Hero */}
      <Section className="pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-stone-100 via-stone-50 to-amber-50/30" />
        <div className="absolute top-20 right-10 w-96 h-96 bg-amber-100/20 rounded-full blur-3xl" />

        <Container className="relative">
          <p className="font-body text-sm tracking-[0.3em] uppercase text-amber-700 mb-4 opacity-0 animate-fade-up">
            {aboutHero.tagline}
          </p>
          <h1 className="font-display text-5xl md:text-6xl font-light text-stone-800 mb-6 opacity-0 animate-fade-up delay-100">
            {aboutHero.title}
            <span className="italic text-amber-800"> {aboutHero.titleEmphasis}</span>
          </h1>
          <p className="font-body text-xl text-stone-600 max-w-2xl opacity-0 animate-fade-up delay-200">
            {aboutHero.subtitle}
          </p>
        </Container>
      </Section>

      {/* Main Bio Section */}
      <Section className="py-20 bg-white">
        <Container>
          <div className="grid lg:grid-cols-3 gap-16">
            {/* Photo Column */}
            <div className="lg:col-span-1">
              <div className="sticky top-32">
                <img
                  src="/images/linda-mundy.jpeg"
                  alt="Dr. Linda Mundy"
                  className="aspect-[3/4] object-cover rounded-sm shadow-2xl"
                />

                {/* Quick Facts */}
                <div className="mt-10 space-y-4">
                  {quickFacts.map((fact, i) => (
                    <div key={i} className="flex justify-between border-b border-stone-100 pb-3">
                      <span className="font-body text-xs tracking-widest uppercase text-stone-400">
                        {fact.label}
                      </span>
                      <span className="font-body text-stone-700">{fact.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Bio Content */}
            <div className="lg:col-span-2">
              <h2 className="font-display text-3xl md:text-4xl font-light text-stone-800 mb-8">
                {aboutBio.title}
                <span className="italic text-amber-800"> {aboutBio.titleEmphasis}</span>
              </h2>

              <div className="space-y-6 font-body text-stone-600 leading-relaxed">
                {aboutBio.paragraphs.map((paragraph, i) => (
                  <p key={i}>{paragraph}</p>
                ))}
              </div>

              {/* Philosophy Quote */}
              <div className="mt-12 p-8 bg-amber-50 border-l-2 border-amber-300">
                <blockquote className="font-display text-xl md:text-2xl text-stone-700 italic leading-relaxed">
                  "{aboutBio.philosophyQuote}"
                </blockquote>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* Credentials Section */}
      <Section className="py-20 bg-stone-100">
        <Container>
          <SectionHeader
            tag="Credentials"
            title="Training & Education"
            centered
          />
          <div className="grid grid-cols-2 gap-8">
            {credentials.map((cred, i) => (
              <CredentialCard key={i} {...cred} />
            ))}
          </div>
        </Container>
      </Section>

      {/* Career Timeline */}
      {/* <Section className="py-20 bg-white">
        <Container>
          <SectionHeader
            tag="Experience"
            title="Career Highlights"
            centered
          />
          <div className="space-y-8">
            {careerHighlights.map((item, i) => (
              <TimelineItem key={i} {...item} />
            ))}
          </div>
        </Container>
      </Section> */}

      {/* CTA Section */}
      <Section className="py-20 bg-stone-800 text-white">
        <Container className="text-center">
          <h2 className="font-display text-3xl md:text-4xl font-light mb-6">
            Ready to Begin Your Journey?
          </h2>
          <p className="font-body text-stone-300 mb-10 max-w-2xl mx-auto">
            Whether you're seeking executive coaching, mindfulness training, or strategic healthcare
            advisory, I'd welcome the opportunity to explore how we might work together.
          </p>
          <button
            onClick={goToContact}
            className="font-body text-sm tracking-widest uppercase px-10 py-4 bg-amber-600 text-white hover:bg-amber-500 transition-colors duration-300"
          >
            Get in Touch
          </button>
        </Container>
      </Section>
    </>
  );
};

export default AboutPage;
